import * as SelectPrimitive from '@radix-ui/react-select';

interface SelectProps {
  options: string[];
  value: string;
  onValueChange: (value: string) => void;
  id?: string;
  placeholder?: string;
}

export default function Select({
  options,
  value,
  onValueChange,
  id,
  placeholder = 'Select...',
}: SelectProps) {
  return (
    <SelectPrimitive.Root value={value} onValueChange={onValueChange}>
      <SelectPrimitive.Trigger className="sel-trigger" id={id}>
        <SelectPrimitive.Value placeholder={placeholder} />
        <SelectPrimitive.Icon className="sel-icon">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M6 9l6 6 6-6" />
          </svg>
        </SelectPrimitive.Icon>
      </SelectPrimitive.Trigger>
      <SelectPrimitive.Portal>
        <SelectPrimitive.Content className="sel-content" position="popper" sideOffset={4}>
          <SelectPrimitive.Viewport className="sel-viewport">
            {options.map((opt) => (
              <SelectPrimitive.Item key={opt} value={opt} className="sel-item">
                <SelectPrimitive.ItemText>{opt}</SelectPrimitive.ItemText>
                <SelectPrimitive.ItemIndicator className="sel-check">
                  <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6.5 11.5L2.5 7.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </SelectPrimitive.ItemIndicator>
              </SelectPrimitive.Item>
            ))}
          </SelectPrimitive.Viewport>
        </SelectPrimitive.Content>
      </SelectPrimitive.Portal>
    </SelectPrimitive.Root>
  );
}
